import { instance3 } from "App/constants";

const urlDelete = "/poolKunjungan/delete";

export const deleteKunjunganById = async (id) => {
  try {
    const res = await instance3.post(urlDelete, { id });
    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      };
    } else {
      return {
        state: false,
        message: res.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const jenisRawatRender = (str) => {
  if (str === "RINAP") {
    return "Rawat Inap";
  } else if (str === "RJALAN") {
    return 'Rawat Jalan';
  } else if (str === "IGD") {
    return "IGD";
  }else{
    return'-';
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    width: "50px",
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "is_main",
    disablePadding: true,
    label: "MAIN",
    sort: false,
    align: "left",
    width: "100px",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "tagihan_id",
    disablePadding: true,
    label: "ID TAGIHAN",
    sort: false,
    align: "left",
  },
  {
    id: "kunjungan_id",
    disablePadding: true,
    label: "ID KUNJUNGAN",
    sort: false,
    align: "left",
  },
  {
    id: "tanggal",
    disablePadding: true,
    label: "TANGGAL",
    sort: false,
    align: "left",
  },
  {
    id: "nama_rm",
    disablePadding: true,
    label: "NAMA RM",
    sort: false,
    align: "left",
  },
  {
    id: "id_rm",
    disablePadding: true,
    label: "ID RM",
    sort: false,
    align: "left",
  },
  {
    id: "instalasi",
    disablePadding: true,
    label: "INSTALASI",
    sort: false,
    align: "left",
  },
  {
    id: "no_sep",
    disablePadding: true,
    label: "NO SEP",
    sort: false,
    align: "left",
  },
];
